<template>
	<div class="payment-locker-view row align-items-center p-2 relative" v-bind="attrsNoStylesClass">

		<div class="col text-center">
			<slot>
				<div class="font-size-5 mb-4">
					Please complete your payment<br/> to get access to further coaching.
				</div>

				<div class="mb-4 font-size-5"><strong>Amount due:
					{{ currencyFormatted(lockerStateData.paymentAmount) }}</strong></div>
			</slot>

<!--			<LoadingIndicator v-if="isProgressShowing"/>-->
			<div v-if="isProgressShowing"></div>
			<div v-if="errorLoadingPaymentOptions" class="card p-3" style="border-color: #ffba00">
				Oops, something went wrong: can't load payment buttons. Please reload this page or contact support.
			</div>
			<div v-else-if="isRecurring && stripeLoaded || !isRecurring && hasConnectedAccounts">
				<div class="mb-3" v-if="stripeLoaded">
					<el-button :id="stripeButtonId"
							   :ref="stripeButtonId"
							   type="primary"
							   v-if="!errorLoadingPaymentOptions"
							   @click="onStripeClicked"
							   :loading="isStripeButtonLoading"
							   style="width: 250px; display: inline-block; padding: 9px;font-size: 14px;">
						Pay by Card
					</el-button>
				</div>
				<div class="mb-3" v-if="cloverEnabled && !isRecurring">
					<el-button :id="cloverButtonId"
							   :ref="cloverButtonId"
							   type="primary"
							   v-if="!errorLoadingPaymentOptions"
							   @click="onCloverClicked"
							   :loading="isCloverButtonLoading"
							   style="width: 250px; display: inline-block; padding: 9px; font-size: 14px;">
						Pay by Card
					</el-button>
				</div>
				<div :id="payPalButtonId" v-if="paypalLoaded" style="width: 250px;"  :style="{'display' : isRecurring ? 'none' : 'inline-block'}"></div>
				<div class="mt-4">
					<small class="text-muted"><i class="fontello icon-lock"/>You will be redirected to a secure checkout page</small>
				</div>
			</div>
			<div v-else-if="!isProgressShowing">
				Seems like your coach haven't added any payment options yet.
				<br/>Please contact your coach to let them know they need to add their billing details.
<!--				<br/>Once your coach completes setting up their billing details, return here to complete the payment.-->
			</div>


		</div>
		<LoadingIndicator :is-loading="isPaymentInProgress || isProgressShowing" :message="progressText"/>
	</div>
</template>

<script>
import {uuidv4} from "@/utils/helpers";
import PaymentSdkManager
	from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/PaymentSdkManager";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import LockerState from "@shared/Program/Locaker/LockerState";

import BaseComponent from "@/core/components/BaseComponent.vue";
import InvoiceItem from "@shared/Invoice/InvoiceItem";

export default {
	extends: BaseComponent,
	name: "CompletePaymentLockerView",
	components: {LoadingIndicator},
	props: {
		lockerState: LockerState,
		invoiceItem: InvoiceItem,
		shouldSaveInvoice: {Boolean, default: false},
		amount: Number,
		invoiceGroupId: String,
		billingDataId: String,
		billingItemIds: Array,
		coachId: String,
		clientId: String
	},

	inheritAttrs: false,

	watch: {
		invoiceItem() {
			this.syncInvoiceFromProp()
		},
		lockerState(){
			this.syncLockerStateFromProp()
		}
	},

	data() {
		return {
			lockerStateData: new LockerState(),
			invoiceItemData: null,
			isPaymentInProgress: false,
			paypalButton: null,
			payPalButtonId: "id" + uuidv4(),
			stripeButtonId: "id" + uuidv4(),
			cloverButtonId: "id" + uuidv4(),
			isStripeButtonLoading: false,
			isCloverButtonLoading: false,
			paymentSdkManager: null,
			stripeLoaded: false,
			paypalLoaded: false,
			cloverEnabled: false,
			stripe: null,
			paypal: null,
			errorLoadingPaymentOptions: false,
			hasConnectedAccounts: false
		}
	},

	async mounted() {
		await this.handleAsync(async () => {
			await this.syncInvoiceFromProp()
			this.syncLockerStateFromProp()
		})
		let isPaymentCompleted = await this.handlePaymentReturnStatus()
		this.paymentSdkManager = new PaymentSdkManager(this.$dataManager, this.coachIdComputed)
		if(!isPaymentCompleted){
			await this.setupPaymentOptions()
		}

	},
	methods: {
		async syncInvoiceFromProp(){
			let invoiceId = this.getQueryParam("invoiceId")
			let invoiceItem
			if(invoiceId && this.shouldSaveInvoice){
				invoiceItem = await this.dataManager.apiGetInvoiceItem({coachId: this.coachId, invoiceId: invoiceId})
			}
			this.invoiceItemData = invoiceItem || this.invoiceItem
			console.log("syncInvoiceFromProp: invoiceItemData = ", this.invoiceItemData)

			this.syncLockerStateFromInvoice()
		},

		syncLockerStateFromInvoice(){
			if(this.invoiceItemData){
				this.lockerStateData.fillFromInvoice(this.invoiceItemData)
			}
			if(this.invoiceItemData && !this.coachId){
				throw Error("coachId must be provided too when invoiceItem is provided")
			}
		},
		syncLockerStateFromProp(){
			if(this.lockerState && !this.invoiceItemData){
				this.lockerStateData = this.lockerState
			}
		},

		async setupPaymentOptions() {

			this.progressDataLoading()


			try {
				let {
					stripe,
					paypal,
					clover
				} = await this.$dataManager.apiGetConnectedBillingAccounts({coachId: this.coachIdComputed})
				console.log("stripe = ", stripe, ", paypal = ", paypal)
				await Promise.all([
					stripe ? this.loadStripeSdk().then(_ => this.stripeLoaded = true) : Promise.resolve(),
					paypal ? this.loadPayPalSdk().then(_ => this.paypalLoaded = true) : Promise.resolve(),
					clover ? this.cloverEnabled = true : this.cloverEnabled = false
				])
				this.hasConnectedAccounts = this.cloverEnabled || this.stripeLoaded || this.paypalLoaded
				this.hideProgress()
				if (this.paypalLoaded) {
					this.setupPayPalButtonLocker()
				}
			} catch (error) {
				this.errorLoadingPaymentOptions = true
				this.handleError(error)
			}

		},

		async loadStripeSdk() {
			this.stripe = await this.paymentSdkManager.loadStripeSdk()
		},

		async loadPayPalSdk() {
			this.paypal = await this.paymentSdkManager.loadPayPalSdk()
		},

		async onPaymentStartedInternal(){
			let res = await this.emitPromise("onPaymentStarted")
			res = res || res === undefined
			if(res){
				await this.syncInvoiceUrl()
			}
			return res
		},

		async onPaymentErrorInternal(){
			this.progressDataLoading("Loading...")
			if(this.shouldSaveInvoice && this.invoiceItemData){
				await this.removeQuery(["invoiceId"])
				await this.dataManager.apiPostRemoveTempInvoice({invoiceId: this.invoiceItemData.id, coachId: this.coachId})
				await this.syncInvoiceFromProp()
			}
			await this.emitPromise("paymentError")
			this.hideProgress()
		},

		async syncInvoiceUrl(){
			if(this.invoiceItemData){
				if(this.shouldSaveInvoice){
					await this.dataManager.apiPostCreateTempInvoice({invoiceItem: this.invoiceItemData, coachId: this.coachId})
				}
				await this.setQuery({invoiceId: this.invoiceItemData.id})
			}
		},

		async handlePaymentReturnStatus(){
			let paymentStatus = this.getQueryParam("payment_status")
			switch (paymentStatus){
				case 'success':
					await this.waitForPaymentCompleted()
					return true
				case 'error':
					return this.onPaymentErrorInternal()
			}
		},

		async waitForPaymentCompleted(){
			let invoiceId = this.getQueryParam("invoiceId")
			console.log("waitForPaymentCompleted: invoiceId = ", invoiceId)
			if(invoiceId){
				await this.waitForInvoiceToBePaid(invoiceId)
			} else {
				this.$emit("paymentSuccess")
			}
		},

		async waitForInvoiceToBePaid(invoiceId){
			this.progressBlocking("Processing payment.\nPlease don't refresh this tab.")
			await this.$authManager.waitForCustomClaimsFor(this.coachIdComputed)

			let stopObserver = await this.dataManager.onSnapshotInvoiceItem(invoiceId, (invoice, error) => {
				console.log("CompletePaymentLockerView.waitForInvoiceToBePaid: invoice = ", invoice, ", error = ", error)
				if(error) {
					this.handleError(error)
					stopObserver()
					return
				}
				if(invoice.isPaid() || invoice.isPartiallyPaid()){
					this.$emit("paymentSuccess", invoice)
					this.hideProgress()
					stopObserver()
				}
			})
		},


		async onStripeClicked() {
			console.log("CompletePaymentLockerView.onStripeClicked")
			this.isPaymentInProgress = true

			try {
				let res = await this.onPaymentStartedInternal()
				console.log("CompletePaymentLockerView.onPaymentStarted completed: res = ", res)
				if (!res) {
					this.isPaymentInProgress = false
					this.hideProgressFail()
					return
				}
				let _ = this.$analyticManager.trackEvent("Pay by card clicked", this.analyticsPropsMethod())
				let requestData = this.createOrderRequest()
				let sessionId = await this.$dataManager.apiPostStripeCreateOrder(requestData)
				let result = await this.stripe.redirectToCheckout({sessionId})
				if (result && result.error) {
					throw result.error
				}
			} catch (error) {
				await this.onPaymentErrorInternal()
				this.handleError(error)
				this.isPaymentInProgress = false
			}
		},

		async onCloverClicked() {
			console.log("CompletePaymentLockerView.onCloverClicked")
			this.isPaymentInProgress = true

			try {
				let res = await this.onPaymentStartedInternal()
				console.log("CompletePaymentLockerView.onPaymentStarted completed: res = ", res)
				if (!res) {
					this.isPaymentInProgress = false
					this.hideProgressFail()
					return
				}
				let _ = this.$analyticManager.trackEvent("Pay by card clicked", this.analyticsPropsMethod())
				let requestData = this.createOrderRequest()
				let url = await this.$dataManager.apiPostCloverOrderStart(requestData)
				window.location.href = url
			} catch (error) {
				await this.onPaymentErrorInternal()
				this.handleError(error)
				this.isPaymentInProgress = false
			}
		},

		setupPayPalButtonLocker() {
			this.paypalButton = this.paypal.Buttons({
				createOrder: async () => this.createOrderFunction(),
				onApprove: async data => await this.onPayPalApproveWrapper(data),
				onError: error => this.onPaymentError(error),
				onCancel: async () => this.onPaymentError("Payment cancelled")
			})
			this.renderPaypalButton()
		},

		// async onPaypalClicked(event) {
		// 	console.log("CompletePaymentLockerView.onPaypalClicked")
		// 	// event.preventDefault()
		// 	let res = await this.emitPromise("paymentStarted")
		// 	if (!res) {
		// 		throw Error("flow not ready")
		// 	}
		// },



		async onPaymentError(error){
			await this.setQuery({payment_status: "error"})
			await this.handlePaymentReturnStatus()
			this.isPaymentInProgress = false
		},

		renderPaypalButton() {
			this.$nextTick(() => {
				let buttonElem = document.getElementById(this.payPalButtonId)
				if (buttonElem) {
					buttonElem.innerHTML = ''
					this.paypalButton.render('#' + this.payPalButtonId);
					// buttonElem.addEventListener("mouseenter", () => this.onPaypalClicked);
				}
			})
		},

		createOrderRequest() {
			return {
				clientId: this.clientIdComputed,
				coachId: this.coachIdComputed,
				invoiceGroupId: this.lockerStateData.invoiceGroupId,
				invoiceId: this.lockerStateData.invoiceGroupId,
				billingDataId: this.lockerStateData.billingDataId,
				billingItemIds: this.lockerStateData.billingItemIds,
				redirectUrl: this.getBrandedLink(window.location.href)
			}
		},


		async createOrderFunction(){
			this.isPaymentInProgress = true
			let orderID
			try{
				let res = await this.onPaymentStartedInternal()
				console.log("CompletePaymentLockerView.onPaymentStarted completed")
				if (!res) {
					this.isPaymentInProgress = false
					this.hideProgressFail()
					return
				}
				this.$analyticManager.trackEvent("Pay by paypal clicked", this.analyticsPropsMethod())
				let requestData = this.createOrderRequest()
				orderID = await this.$dataManager.apiPostPayPalCreateOrder(requestData)

			} catch (error){
				this.handleError(error)
				this.$emit("paymentError", error)
			}
			return orderID
		},

		async onPayPalApproveWrapper(data) {
			let requestData = this.createOrderRequest()
			this._showProgressDataLoadingInternal()
			try {
				let res = await this.$dataManager.apiPostPayPalApproveOrder({...requestData, orderId: data.orderID})
				await this.setQuery({payment_status: "success"})
				await this.waitForPaymentCompleted()
				this.isPaymentInProgress = false
				 this.hideProgress()
				return res
			} catch (error) {
				this.isPaymentInProgress = false
				this.hideProgress()
				throw error
			}
		},

		analyticsPropsInternal() {
			return {
				label: "Complete payment locker"
			}
		}
	},

	computed: {
		coachIdComputed() {
			return this.coachId || this.$dataManager.ownerId
		},
		clientIdComputed() {
			let clientId
			if(this.userProfile){
				clientId = this.userProfile.getClientProfileIdByCoachId(this.coachIdComputed)
			}
			return this.clientId || clientId
		},
		isRecurring(){
			return this.invoiceItemData ? this.invoiceItemData.isRecurringInvoice : false
		}
	},
}
</script>

<style lang="scss">
.payment-locker-view {
	min-height: 300px;

}

</style>
